import moment from "moment";
import httpClient from "../../lib/httpClient";
export const computeDopplerFrequencyAndData = async (latitude, longitude, dateOfEvent) => {
  const dateAsYYYYMMDD = moment(dateOfEvent).format("YYYYMMDD");
  let foundDopplerFrequency = 0;
  await httpClient()
    .post("/proxy/doppler", {
      lat: latitude,
      lng: longitude,
      frequency: 12,
      check: true,
      date: dateAsYYYYMMDD,
    })
    .then((resp) => resp.data)
    .then((data) => {
      //console.log("computeDopplerFrequencyAndData:check 12", data);
      if (data.data === 1) foundDopplerFrequency = 12;
    })
    .catch((error) => {
      console.error(error);
      return null;
    });
  await httpClient()
    .post("/proxy/doppler", {
      lat: latitude,
      lng: longitude,
      frequency: 48,
      check: true,
      date: dateAsYYYYMMDD,
    })
    .then((resp) => resp.data)
    .then((data) => {
      //console.log("computeDopplerFrequencyAndData:check 48", data);
      if (data.data === 1) foundDopplerFrequency = 48;
    })
    .catch((error) => {
      console.error(error);
      return null;
    });
  return { latitude, longitude, dateAsYYYYMMDD, foundDopplerFrequency };
};
